/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PostApiV1NotificationMobileAppMutationRequest,
  PostApiV1NotificationMobileAppMutationResponse,
  PostApiV1NotificationMobileApp400,
  PostApiV1NotificationMobileApp401,
  PostApiV1NotificationMobileApp500,
} from "../../types/notificationMobileAppController/PostApiV1NotificationMobileApp.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { postApiV1NotificationMobileApp } from "../../clients/notificationMobileAppController/postApiV1NotificationMobileApp.ts";

export const postApiV1NotificationMobileAppMutationKey = () =>
  [{ url: "/api/v1/notification/mobile-app" }] as const;

export type PostApiV1NotificationMobileAppMutationKey = ReturnType<
  typeof postApiV1NotificationMobileAppMutationKey
>;

export function postApiV1NotificationMobileAppMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiV1NotificationMobileAppMutationRequest>
  > & { client?: Client } = {},
) {
  const mutationKey = postApiV1NotificationMobileAppMutationKey();
  return mutationOptions<
    PostApiV1NotificationMobileAppMutationResponse,
    ResponseErrorConfig<
      | PostApiV1NotificationMobileApp400
      | PostApiV1NotificationMobileApp401
      | PostApiV1NotificationMobileApp500
    >,
    { data?: PostApiV1NotificationMobileAppMutationRequest },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return postApiV1NotificationMobileApp(data, config);
    },
  });
}

/**
 * @description Cria uma notificação push para as turmas informadas. NotificationType deve ser Pendente (1), Agendado (2) ou Rascunho (6). Rascunho apenas salva o registro sem enfileirar no Hangfire. Agendado requer o campo ScheduledAtUtc preenchido. **(Requer Authorization para autenticação)**
 * @summary Cria uma notificação mobile (Requer Authorization para autenticação)
 * {@link /api/v1/notification/mobile-app}
 */
export function usePostApiV1NotificationMobileApp<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiV1NotificationMobileAppMutationResponse,
      ResponseErrorConfig<
        | PostApiV1NotificationMobileApp400
        | PostApiV1NotificationMobileApp401
        | PostApiV1NotificationMobileApp500
      >,
      { data?: PostApiV1NotificationMobileAppMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiV1NotificationMobileAppMutationRequest>
    > & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? postApiV1NotificationMobileAppMutationKey();

  const baseOptions = postApiV1NotificationMobileAppMutationOptions(
    config,
  ) as UseMutationOptions<
    PostApiV1NotificationMobileAppMutationResponse,
    ResponseErrorConfig<
      | PostApiV1NotificationMobileApp400
      | PostApiV1NotificationMobileApp401
      | PostApiV1NotificationMobileApp500
    >,
    { data?: PostApiV1NotificationMobileAppMutationRequest },
    TContext
  >;

  return useMutation<
    PostApiV1NotificationMobileAppMutationResponse,
    ResponseErrorConfig<
      | PostApiV1NotificationMobileApp400
      | PostApiV1NotificationMobileApp401
      | PostApiV1NotificationMobileApp500
    >,
    { data?: PostApiV1NotificationMobileAppMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiV1NotificationMobileAppMutationResponse,
    ResponseErrorConfig<
      | PostApiV1NotificationMobileApp400
      | PostApiV1NotificationMobileApp401
      | PostApiV1NotificationMobileApp500
    >,
    { data?: PostApiV1NotificationMobileAppMutationRequest },
    TContext
  >;
}
